import React, { useEffect, useCallback } from 'react'
import { useFormik } from 'formik'
import { object, string } from 'yup'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { auth, db } from '../firebase-config'
import { doc, getDoc, updateDoc } from 'firebase/firestore'
import {
  updateEmail,
  EmailAuthProvider,
  reauthenticateWithCredential,
} from 'firebase/auth'
import { Button } from '../components/Button'
import { Input } from '../components/Input'
import { Error } from '../components/Error'

const requiredMsg = 'Dieses Feld ist verpflichtend'

const validateEditEmail = object({
  password: string().min(7, 'mindestens 7 Zeichen').required(requiredMsg),
  email: string()
    .email('muss eine gültige E-Mail sein')
    .max(255)
    .required(requiredMsg),
})

const initialValues = {
  email: '',
  password: '',
}

export const EditEmail = () => {

  const user = auth.currentUser
  const userRef = doc(db, 'users', user.uid)

  const formik = useFormik({
    initialValues,
    validationSchema: validateEditEmail,
    onSubmit: (values) => {
      handleSubmit(values)
    },
  })

  const getProfile = useCallback(
    async function getProfile() {
      const profile = await getDoc(userRef)
      formik.setFieldValue('email', profile.data().email)
    },
    [formik, userRef],
  )

  async function handleSubmit(values) {
    const credential = EmailAuthProvider.credential(user.email, values.password)

    reauthenticateWithCredential(user, credential)
      .then(() => {
        updateEmail(auth.currentUser, values.email)
          .then(async () => {
            await updateDoc(userRef, {
              email: values.email,
            })
          })
          .catch((error) => {
            error.code === 'auth/email-already-in-use'
              ? toast.error(
                  'Die angegebene E-Mail ist schon in Verwendung. Bitte versuchen Sie es mit einer anderen.',
                  {
                    position: 'top-center',
                  },
                )
              : toast.error(
                  'Es ist leider ein Fehler aufgetreten. Kontrolliere nochmal deine Eingaben und versuche es erneut.',
                  {
                    position: 'top-center',
                  },
                )
          })
      })
      .then(() => {
        toast.success('Deine E-Mail Adresse wurde erfolgreich aktualisiert.', {
          position: 'top-center',
        })
        formik.setFieldValue('password', '')
        formik.setFieldTouched('password', false)
      })
      .catch(() => {
        toast.error(
          'Leider konnten wir deine E-Mail-Änderung nicht verarbeiten. Kontrolliere nochmal deine Eingaben und versuche es erneut.',
          {
            position: 'top-center',
          },
        )
      })
  }

  useEffect(() => {
    getProfile()
  }, [])

  return (
    <form onSubmit={formik.handleSubmit}>
      <Input
        name='email'
        type='email'
        label='E-Mail'
        placeholder='mustershop@email.com'
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.email}
        required={true}
      />
      {formik.touched.email && formik.errors.email && (
        <Error msg={formik.errors.email} />
      )}
      <Input
        name='password'
        type='password'
        label='Aktuelles Passwort'
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.password}
      />
      {formik.touched.password && formik.errors.password && (
        <Error msg={formik.errors.password} />
      )}
      <Button type='submit'>bestätigen und speichern</Button>
    </form>
  )
}
